var React = require('react');

function ShapeGroup5 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.7","d":"M1143.02 398.709C1143.02 398.709 1191.5 749.747 1039.29 840.046C892.911 926.889 615.171 740.369 615.171 740.369C615.171 740.369 566.684 389.331 718.893 299.032C865.277 212.189 1143.02 398.709 1143.02 398.709Z","fill":"#EFA891","key":0}),React.createElement("path",{"opacity":"0.7","d":"M404.125 729.031C571.805 807.672 647.842 462.651 846.173 576.245C1044.5 689.838 857.539 283.515 689.859 204.874C522.179 126.233 545.123 405.123 238.95 291.461C-67.2232 177.798 236.445 650.39 404.125 729.031Z","fill":"#2A4C7E","key":1}),React.createElement("circle",{"opacity":"0.7","cx":"386.5","cy":"101.5","r":"101.5","fill":"#EFA891","key":2})]);
}

ShapeGroup5.defaultProps = {"width":"1211","height":"905","viewBox":"0 0 1211 905","fill":"none"};

module.exports = ShapeGroup5;

ShapeGroup5.default = ShapeGroup5;
